export const TaxStatusesConstant: string[] = [
  'Taxable',
  'Exempt'
]

export const TaxStatuses = {
  Taxable:'Taxable',
  Exempt: 'Exempt'
}
